<template>
    <div>
        <div class="top-box">
            <el-button type="primary" @click="addArticle" size="small">添加</el-button>
            <div class="search-box">
                <el-input v-model="keywords" placeholder="请输入查询标题" size="small"></el-input>
                <el-button type="primary" size="small" @click="onSearch">搜索</el-button>
            </div>
        </div>
        <div class="table-box">
            <el-table :data="tableData" border style="width: 100%">
                <el-table-column type="index" label="序号" width="100" align="center" :index="indexMethod">
                </el-table-column>
                <el-table-column prop="title" label="标题" align="center" width="150" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="type" label="类型" align="center" width="200" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="description" label="描述" align="center" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="readnum" label="浏览量" align="center" width="100" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="time" label="日期" align="center" width="200" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="switch" label="开关" align="center" width="100">
                    <template slot-scope="scope">
                        <el-switch @change="onSwitch(scope.row)" v-model="scope.row.switch" active-color="#13ce66"
                            inactive-color="#ff4949" inactive-value="0" active-value="1">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="200" align="center">
                    <template slot-scope="scope">
                        <el-button type="primary" size="small" @click="editArticle(scope.row)">编辑</el-button>
                        <el-button type="danger" size="small" @click="deleteArticle(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="page-box">
            <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize"
                @current-change="handleCurrentChange" @prev-click="prevCilck" @next-click="nextCilck"
                :current-page.sync="page">
            </el-pagination>
        </div>
        <div v-if="DialogVisible">
            <el-dialog :title="DialogTitle" :visible.sync="DialogVisible" width="40%" :destroy-on-close="true">
                <AddArticle v-on:onDialog="upDialogStatus" v-bind:editID="editID"></AddArticle>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import AddArticle from "./addArticle.vue";
export default {
    components: {
        AddArticle,
    },
    data() {
        return {
            keywords: "",
            tableData: [],
            DialogVisible: false,
            DialogTitle: "",
            editID: 0,
            total: 0,
            page: 1,
            pageSize: 10,
        };
    },
    methods: {
        async getArticleList() {
            const { data: res } = await this.$axios.post("/article", {
                keywords: this.keywords,
                page: this.page,
                pageSize: this.pageSize,
            });
            this.tableData = res.data.list;
            this.total = res.data.total;
            console.log(res);
        },
        async deleteArticle(e) {
            console.log(e);
            const { data: res } = await this.$axios.post("/article/delArticle", e);
            console.log(res);
            if (res.meta.status !== 200) return this.$message.error(res.meta.msg);
            this.getArticleList();
            return this.$message.success(res.meta.msg);
        },
        async onSwitch(e) {
            const { data: res } = await this.$axios.post("/article/editArticle", {
                id:e.id,
                switch:e.switch
            });
            console.log(res);
            if (res.meta.status !== 200) return this.$message.error(res.meta.msg);
            return this.$message.success(res.meta.msg);
        },
        editArticle(e) {
            this.DialogVisible = true;
            this.DialogTitle = "编辑文章";
            this.editID = e.id;
            console.log(e);
        },
        addArticle() {
            this.DialogVisible = true;
            this.DialogTitle = "添加文章";
            this.editID = 0;
        },
        async onSearch() {
            this.page = 1;
            const { data: res } = await this.$axios.post("/article", {
                keywords: this.keywords,
                page: this.page,
                pageSize: this.pageSize,
            });
            console.log(res);
            this.tableData = res.data.list;
            this.total = res.data.total;
        },
        async handleCurrentChange(page) {
            this.page = page;
            const { data: res } = await this.$axios.post("/message", {
                keywords: this.keywords,
                page: this.page,
                pageSize: this.pageSize,
            });
            this.tableData = res.data.list;
            this.total = res.data.total;
            console.log(res);
        },
        async prevCilck(page) {
            console.log(page);
            this.page = page;
            const { data: res } = await this.$axios.post("/message", {
                keywords: this.keywords,
                page: this.page,
                pageSize: this.pageSize,
            });
            this.tableData = res.data.list;
            this.total = res.data.total;
            console.log(res);
        },
        async nextCilck(page) {
            console.log(page);
            this.page = page;
            const { data: res } = await this.$axios.post("/message", {
                keywords: this.keywords,
                page: this.page,
                pageSize: this.pageSize,
            });
            this.tableData = res.data.list;
            this.total = res.data.total;
            console.log(res);
        },
        upDialogStatus(e) {
            this.DialogVisible = e;
            this.getArticleList();
        },
        indexMethod(index) {
            if (this.total < this.pageSize) {
                return this.total - index;
            } else {
                return this.total - (this.page - 1) * this.pageSize - index;
            }
        },
    },
    created() {
        this.getArticleList();
    },
};
</script>

<style lang="less">
.top-box {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .search-box {
        display: flex;
        align-items: center;

        .el-input {
            min-width: 350px;
            margin-right: 10px;
        }
    }
}

.table-box {
    margin-top: 20px;
}

.page-box {
    margin-top: 10px;
    float: right;
}
</style>


// WEBPACK FOOTER //
// src/components/article/article.vue